import notHandledHere from './notHandledHere';
import { database, metadata } from 'lib_ui-services';

const _p = { getRelationMetadata: metadata.getRelationMetadata, database };
export const _private = _p;

export default {
    verb: 'doingRefresh',
    excludedNamespaceRelations: notHandledHere,
    description: 'Resync the current relation',
    //this is the actual logic:
    logic: doingRefresh
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function doingRefresh({ data, context }) {
    const { namespace, relation } = context;
    const db = _p.database.get();
    await db.synchronization.syncOneRelation({ namespaceTitle: namespace, relationTitle: relation });
    return { ...data, namespace, relation };
}
